import React from 'react';
import PropTypes from 'prop-types';

const LogoutButton = ({ onClick }) => (
  <a onClick={onClick}>Log out</a>
);
LogoutButton.propTypes = {
  onClick: PropTypes.func,
};

export default LogoutButton;
